import styled from "styled-components";
import { ptToVwConverter } from "../../utils";
import { Button } from "@material-ui/core";

export const ShareWrapper = styled.div`
  margin-top: ${ptToVwConverter(40)}vw;
`;

export const ShareButton = styled(Button)`
  && {
    width: 100%;
    height: 100%;
    text-transform: none;
    background-color: #f2f2f2;
    border-radius: 0;
    @media (max-width: 1024px) {
      font-size: 12px;
    }
  }
`;
// padding: 0 25px;
